var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:{
      cellBoolean: _vm.colorSetting ? false : _vm.value === false || _vm.isWork == _vm.showJudge,
      'form-item-click': !!_vm.routerName,
    },staticStyle:{"fontsize":"14px"},on:{"click":_vm.jumpRouter}},[_vm._v(_vm._s(_vm.showJudge))])])
}
var staticRenderFns = []

export { render, staticRenderFns }